/* Seasonal decoration is opt-in. Ordinary rows keep their existing geometry. */
.tvl-home-collection-row.tvl-seasonal-row {
  position:relative; isolation:isolate; --tvl-seasonal-space:0px;
  /* Geometry changes once; the motion helper animates visual layers only. */
  transition:none;
}
.tvl-home-collection-row.tvl-seasonal-expanded {
  padding-top:var(--tvl-seasonal-space); padding-bottom:var(--tvl-seasonal-space);
}
.tvl-home-collection-row.tvl-seasonal-expanded[data-seasonal-expansion="fullscreen"] {
  padding-top:var(--tvl-seasonal-space-top); padding-bottom:var(--tvl-seasonal-space-bottom);
}
.tvl-seasonal-row > :not(.tvl-seasonal-backdrop) { position:relative; z-index:1; }
.tvl-seasonal-backdrop {
  position:absolute; z-index:0; pointer-events:none; top:-1rem; bottom:-1rem; left:0; right:0;
  overflow:hidden;
  -webkit-mask-image:linear-gradient(transparent,#000 20%,#000 80%,transparent);
  mask-image:linear-gradient(transparent,#000 20%,#000 80%,transparent);
}
.tvl-seasonal-scene {
  position:absolute;top:0;bottom:0;left:0;right:0;
  background-size:100% var(--tvl-seasonal-art-height,100%);background-repeat:no-repeat;background-position:center;
}
.tvl-seasonal-row[data-seasonal-background="parallax"] .tvl-seasonal-scene { left:-7.5%;right:-7.5%; }
.tvl-seasonal-focused[data-seasonal-background="parallax"] .tvl-seasonal-scene { will-change:transform; }
.tvl-seasonal-row .tvl-home-row-title { text-shadow:0 2px 12px #000,0 1px 3px #000; }
.tvl-seasonal-row[data-seasonal-expansion="fullscreen"] .tvl-home-row-title { position:relative; }
.tvl-seasonal-title-plain { transition:opacity .22s ease; }
.tvl-seasonal-title-themed {
  position:absolute;bottom:0;left:0;max-width:100%;pointer-events:none;
  font-family:var(--tvl-seasonal-title-font,Georgia,serif);font-weight:var(--tvl-seasonal-title-weight,400);
  font-size:2.35em;line-height:1.2;letter-spacing:.015em;overflow-wrap:break-word;
  opacity:0;transform:translateY(.2em) scale(.8);transform-origin:left bottom;
  transition:opacity .25s ease,transform .3s ease;
}
.tvl-seasonal-expanded .tvl-seasonal-title-plain { opacity:0; }
.tvl-seasonal-expanded .tvl-seasonal-title-themed { opacity:1;transform:translateY(0) scale(1); }
.tvl-seasonal-row[data-seasonal-theme="halloween"][data-seasonal-style="classic"] .tvl-seasonal-title-themed { color:#ffc273; }
.tvl-seasonal-row[data-seasonal-theme="halloween"][data-seasonal-style="storybook"] .tvl-seasonal-title-themed { color:#eed0ff; }
.tvl-seasonal-row[data-seasonal-theme="halloween"][data-seasonal-style="photoreal"] .tvl-seasonal-title-themed { color:#e6ddbe;letter-spacing:.07em; }
.tvl-seasonal-row[data-seasonal-theme="halloween"][data-seasonal-style="nightmare"] .tvl-seasonal-title-themed { color:#ddaba3;text-shadow:0 3px 0 #5c1719,0 3px 14px #000; }
.tvl-seasonal-row[data-seasonal-theme="christmas"][data-seasonal-style="classic"] .tvl-seasonal-title-themed { color:#ffe4a8; }
.tvl-seasonal-row[data-seasonal-theme="christmas"][data-seasonal-style="storybook"] .tvl-seasonal-title-themed { color:#e0f9ff; }
.tvl-seasonal-row[data-seasonal-theme="christmas"][data-seasonal-style="photoreal"] .tvl-seasonal-title-themed { color:#f4e6c3;letter-spacing:.055em; }
.tvl-seasonal-row .tvl-home-row-caption { text-shadow:0 1px 5px #000; }
.tvl-home-row-art .tvl-seasonal-frame {
  position:absolute; z-index:4; top:0; left:0; width:100%; height:100%; pointer-events:none;
  object-fit:fill; border-radius:inherit;
}
/* Preserve the entire poster, including titles printed along its edges. These
   safe rectangles sit inside the rails/arch; only the poster is inset. */
.tvl-home-row-art[data-seasonal-frame] {
  --tvl-poster-top:8%; --tvl-poster-side:8%; --tvl-poster-bottom:7%;
}
[data-seasonal-frame-style="classic"] .tvl-home-row-art[data-seasonal-frame="halloween"] {
  --tvl-poster-top:16%; --tvl-poster-side:9%; --tvl-poster-bottom:6%;
}
[data-seasonal-frame-style="classic"] .tvl-home-row-art[data-seasonal-frame="christmas"] {
  --tvl-poster-top:13%;
}
.tvl-home-row-art .tvl-seasonal-poster {
  position:absolute; top:var(--tvl-poster-top); left:var(--tvl-poster-side);
  width:calc(100% - var(--tvl-poster-side) * 2);
  height:calc(100% - var(--tvl-poster-top) - var(--tvl-poster-bottom));
  object-fit:contain;
}
/* Crop the transparent margins in the authored 1036 x 1518 photo frames.
   Their apertures overlap the opaque inner rail slightly to avoid seams. */
.tvl-home-row-art[data-seasonal-frame-shape="halloween"] {
  --tvl-poster-top:18%; --tvl-poster-side:12%; --tvl-poster-bottom:2%;
  --tvl-frame-left:-3.07377%; --tvl-frame-width:106.14754%; --tvl-frame-height:100%;
  --tvl-frame-opening:polygon(9.73% 100%,9.73% 16.67%,12.30% 14.49%,22.54% 12.52%,32.79% 10.67%,43.03% 9.49%,50% 9.22%,56.97% 9.49%,67.21% 10.67%,77.46% 12.52%,87.70% 14.49%,90.27% 16.67%,90.27% 100%);
}
.tvl-home-row-art[data-seasonal-frame-shape="christmas"] {
  --tvl-poster-top:12%; --tvl-poster-side:9%; --tvl-poster-bottom:7%;
  --tvl-frame-left:-2.96524%; --tvl-frame-width:105.93047%; --tvl-frame-height:102.29111%;
  --tvl-frame-opening:inset(7.07547% 6.74847% 4.44744% 6.74847%);
}
.tvl-home-row-art[data-seasonal-frame-shape],
.tvl-home-preview .tvl-home-row-art[data-seasonal-frame-shape].tvl-no-art { background:transparent; border:0; }
.tvl-home-row-art[data-seasonal-frame-shape].tvl-no-art::before { content:none; }
.tvl-seasonal-aperture {
  position:absolute; top:0; right:0; bottom:0; left:0;
  clip-path:var(--tvl-frame-opening); background:#1c1e26;
}
.tvl-no-art > .tvl-seasonal-aperture { background:linear-gradient(135deg,#34454b,#1a2025); }
.tvl-home-row-art[data-seasonal-frame-shape] > .tvl-seasonal-frame {
  left:var(--tvl-frame-left); width:var(--tvl-frame-width); height:var(--tvl-frame-height); max-width:none; border-radius:0;
}
.tvl-seasonal-cover { position:absolute; z-index:3; top:0; right:0; bottom:0; left:0; overflow:hidden; border-radius:inherit; pointer-events:none; }
.tvl-seasonal-panel { position:absolute; top:0; bottom:0; width:50.5%; background:#251917; overflow:hidden; transition:transform .38s ease; }
/* Keep closed doors flattened: permanent 3D layers for a long row can exhaust
   the TV compositor. Promote only the opening door and its closing transition. */
.tvl-seasonal-reveal-active .tvl-seasonal-cover { perspective:650px; }
.tvl-seasonal-reveal-active .tvl-seasonal-panel,
.tvl-seasonal-reveal-active .tvl-seasonal-advent-flap { backface-visibility:hidden; }
.tvl-seasonal-panel-left { left:0; transform-origin:left center; }
.tvl-seasonal-panel-right { right:0; transform-origin:right center; }
.tvl-seasonal-door-art { width:100%; height:100%; object-fit:fill; }
.tvl-seasonal-item-open .tvl-seasonal-panel-left { transform:rotateY(-105deg); }
.tvl-seasonal-item-open .tvl-seasonal-panel-right { transform:rotateY(105deg); }
.tvl-seasonal-door-number {
  position:absolute; top:42%; left:50%; transform:translate(-50%,-50%); color:#ffe3a2;
  font:bold 2.5rem Georgia,serif; text-shadow:0 2px 5px #000; transition:opacity .18s ease;
  background:#571c23e8; border:1px solid #cda95e; border-radius:50%; min-width:1.6em; line-height:1.6; text-align:center;
}
.tvl-seasonal-item-open .tvl-seasonal-door-number { opacity:0; }
.tvl-seasonal-advent-flap {
  position:absolute; top:0; right:0; bottom:0; left:0; background:#642837;
  transform-origin:left center; transition:transform .42s ease;
}
.tvl-home-row-art .tvl-seasonal-advent-art { width:100%; height:100%; object-fit:fill; }
.tvl-home-row-art .tvl-seasonal-advent-number { position:absolute; top:34.3%; left:30%; width:40%; height:30%; object-fit:contain; }
.tvl-seasonal-item-open .tvl-seasonal-advent-flap { transform:rotateY(-105deg); }
[data-seasonal-reveal="advent"]:not(.tvl-seasonal-item-open):not(.tvl-advent-locked) .tvl-home-row-caption { opacity:0; }
.tvl-advent-locked .tvl-home-row-caption { color:#d5cbb9; }
[data-seasonal-reveal="curtains"] .tvl-seasonal-panel {
  width:51%; background:repeating-linear-gradient(90deg,#150d22 0%,#462641 12%,#28152a 22%,#130c1c 30%);
  border-bottom:4px solid #957047; box-shadow:inset 0 14px 22px #0008;
}
[data-seasonal-theme="christmas"][data-seasonal-reveal="curtains"] .tvl-seasonal-panel {
  background:repeating-linear-gradient(90deg,#340d19 0%,#9e293c 12%,#64192d 22%,#310c17 30%); border-color:#dab76b;
}
.tvl-seasonal-item-open[data-seasonal-reveal="curtains"] .tvl-seasonal-panel-left { transform:translateX(-96%); }
.tvl-seasonal-item-open[data-seasonal-reveal="curtains"] .tvl-seasonal-panel-right { transform:translateX(96%); }
[data-seasonal-reveal="doors"]:not(.tvl-seasonal-item-open) .tvl-home-row-caption,
[data-seasonal-reveal="curtains"]:not(.tvl-seasonal-item-open) .tvl-home-row-caption { opacity:0; }
.tvl-seasonal-row .tvl-home-row-caption { transition:opacity .18s ease; }
/* Preview uses the same decoration with its existing smaller cards. */
.tvl-home-preview .tvl-seasonal-backdrop { left:-1rem; right:-1rem; }
.tvl-home-preview .tvl-seasonal-door-number { font-size:1.6rem; }
.tvl-home-preview .tvl-seasonal-title-themed { font-size:1.8em; }
@media (prefers-reduced-motion:reduce) {
  .tvl-home-collection-row.tvl-seasonal-row,.tvl-seasonal-panel,.tvl-seasonal-advent-flap,.tvl-seasonal-door-number,.tvl-seasonal-row .tvl-home-row-caption,.tvl-seasonal-title-plain,.tvl-seasonal-title-themed { transition:none; }
  .tvl-seasonal-scene { will-change:auto; }
}


.tvl-home-row-art .tvl-seasonal-full-door { position:absolute; top:0; width:200%; height:100%; max-width:none; object-fit:fill; }
.tvl-seasonal-panel-left .tvl-seasonal-full-door { left:0; }
.tvl-seasonal-panel-right .tvl-seasonal-full-door { right:0; }
[data-seasonal-cover-style="nightmare"] .tvl-seasonal-door-art { filter:brightness(.68) saturate(.35); }
[data-seasonal-frame-style="nightmare"] .tvl-seasonal-frame { filter:brightness(.7) saturate(.35); }
[data-seasonal-reveal="shutters"] .tvl-seasonal-panel::after {
  content:''; position:absolute; top:0; right:0; bottom:0; left:0; pointer-events:none;
  background:repeating-linear-gradient(0deg,#0007 0px,#0007 2px,transparent 3px,transparent 13px,#fff2 14px,transparent 16px);
  box-shadow:inset 0 0 0 5px #1b151699;
}
.tvl-seasonal-window { position:absolute; z-index:2; top:0; right:0; bottom:0; left:0; pointer-events:none; border:5px solid #80634b; box-shadow:inset 0 0 0 1px #e0c28b55; border-radius:inherit; }
.tvl-seasonal-window::before,.tvl-seasonal-window::after { content:''; position:absolute; background:#80634b; box-shadow:0 0 3px #000; }
.tvl-seasonal-window::before { width:3px; height:100%; left:calc(50% - 1px); top:0; }
.tvl-seasonal-window::after { height:3px; width:100%; top:38%; left:0; }
[data-seasonal-theme="christmas"] .tvl-seasonal-window { border-color:#bda36b; }
[data-seasonal-theme="christmas"] .tvl-seasonal-window::before,[data-seasonal-theme="christmas"] .tvl-seasonal-window::after { background:#bda36b; }
[data-seasonal-cover-style="storybook"][data-seasonal-reveal="curtains"] .tvl-seasonal-panel { background:repeating-linear-gradient(90deg,#503674,#996bb6 12%,#734d8f 22%,#39275e 30%); }
[data-seasonal-theme="christmas"][data-seasonal-cover-style="storybook"][data-seasonal-reveal="curtains"] .tvl-seasonal-panel { background:repeating-linear-gradient(90deg,#4b2134,#bf5564 12%,#8a344e 22%,#592137 30%); }
[data-seasonal-reveal="shutters"]:not(.tvl-seasonal-item-open) .tvl-home-row-caption { opacity:0; }
